module.exports = __webpack_public_path__ + "img/freespin1.e5305316.png";